export default "__VITE_ASSET__048edb55__"